import { Tool } from './types';

export const ZONE_COLORS = ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#ec4899', '#06b6d4', '#84cc16'];

/** Pixel radius within which clicking the first point closes a polygon */
export const CLOSE_POLYGON_RADIUS = 4;

/** Pixel radius used for vertex hit-testing (click/hover detection) */
export const VERTEX_HIT_RADIUS = 8;

export const TOOL_ICONS: Record<Tool, JSX.Element> = {
    polygon: (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <polygon points="8,1 15,6 12,14 4,14 1,6" stroke="currentColor" strokeWidth="1.5" fill="none" />
        </svg>
    ),
    select: (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
                d="M3 2l10 5.5-5 1.5-2 5z"
                stroke="currentColor"
                strokeWidth="1.5"
                fill="none"
                strokeLinejoin="round"
            />
        </svg>
    ),
    move: (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
                d="M8 2v12M2 8h12M8 2L6 4M8 2l2 2M8 14l-2-2M8 14l2-2M2 8l2-2M2 8l2 2M14 8l-2-2M14 8l-2 2"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </svg>
    ),
};

export const TOOL_TIPS: Record<Tool, JSX.Element> = {
    polygon: (
        <>
            <div>• Click to add points</div>
            <div>• Click 1st point or dbl-click to close</div>
            <div>• Ctrl+Z to undo last point</div>
            <div>• Esc to cancel</div>
        </>
    ),
    select: (
        <>
            <div>• Click zone to select</div>
            <div>• Drag vertex to reshape</div>
            <div>• Click edge midpoint to add vertex</div>
            <div>• Right-click vertex to delete it</div>
        </>
    ),
    move: (
        <>
            <div>• Drag zone to move it</div>
            <div>• Drag vertex to reshape</div>
        </>
    ),
};
